import { Alert } from 'avo-ui'
import { BrandSection } from 'components/award/nomination/brand-section/BrandSection'
import { useEffect, useState } from 'react'
import { API_AWARD } from 'services/apiAward'
import { METHOD } from 'services/method'
import { useFetch } from 'services/useFetch'
import { uploadFileToS3 } from 'utils/utils'

const INITIAL_STATE = {
    is_show: false,
    title_image_url: null,
    description: null,
    brands: [
        {
            image_url: null,
            title: null,
        },
    ],
}

export const BrandSectionContainer = () => {
    const [brandDetail, setBrandDetail] = useState(INITIAL_STATE)
    const copyItems = [...(brandDetail?.brands || [])]
    const [errorForm, setErrorForm] = useState({})
    const [isLoadingUpload, setLoadingUpload] = useState(false)
    const { fetching: getBrand, isLoading } = useFetch(API_AWARD.NOMINATION_BRAND)
    const { fetching: updateBrand, isLoading: isUpdating } = useFetch({
        ...API_AWARD.NOMINATION_BRAND,
        method: METHOD.PUT,
    })
    const { fetching: getURLImage } = useFetch(API_AWARD.URL_AWARD_IMAGE)

    useEffect(() => {
        fetchBrand()
    }, [])

    const fetchBrand = async () => {
        const response = await getBrand()
        let responseData = response?.data

        if (response?.data?.brands?.length === 0) {
            responseData = {
                ...responseData,
                brands: [
                    {
                        image_url: null,
                        title: null,
                    },
                ],
            }
        }
        setBrandDetail(responseData)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setBrandDetail({ ...brandDetail, [name]: value })
    }

    const setItems = (items) => {
        setBrandDetail({ ...brandDetail, brands: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                image_url: null,
                title: null,
            },
        ])
    }

    const handleUploadImage = async (files) => {
        let newFormImage = {}
        if (files?.title_image_url) {
            const s3Urls = await getURLImage({ files: [files?.title_image_url?.name] })
            await uploadFileToS3(s3Urls?.data?.[0], files?.title_image_url?.file)
            newFormImage = {
                ...newFormImage,
                title_image_url: `${s3Urls?.data?.[0]?.url}${s3Urls?.data?.[0]?.fields?.key}`,
            }
        }

        if (files?.brands?.length > 0) {
            let newFiles = []
            const fileNames = files?.brands.map((item) => item.image_url.name)
            const s3Urls = await getURLImage({ files: fileNames })

            await Promise.all(
                s3Urls?.data?.map(async (item, index) => {
                    const itemFile = { image_url: '', currentIndex: '' }
                    await uploadFileToS3(item, files?.brands[index]?.image_url?.file)
                    itemFile.image_url = `${item?.url}${item?.fields?.key}`
                    itemFile.currentIndex = files?.brands[index]?.currentIndex
                    newFiles.push(itemFile)
                }),
            )
            newFormImage = { ...newFormImage, brands: [...newFiles] }
        }

        return newFormImage
    }

    const validationForm = () => {
        const newErrorForm = { ...errorForm }
        if (!brandDetail.title_image_url) {
            newErrorForm.title_image_url = 'Image title wajib diisi'
        } else {
            newErrorForm.title_image_url = ''
        }

        const errorArrayItem = []
        for (const item of brandDetail.brands) {
            const itemError = { image_url: '', title: '' }
            if (!item.image_url) itemError.image_url = 'Image icon wajib diisi'
            if (!item.title) itemError.title = 'Title wajib diisi'
            errorArrayItem.push(itemError)
        }
        newErrorForm.brands = [...errorArrayItem]

        return newErrorForm
    }

    const isValid = (data) => {
        if (typeof data === 'string') {
            return data === ''
        }
        if (Array.isArray(data)) {
            return data.every(isValid)
        }
        if (typeof data === 'object' && data !== null) {
            return Object.values(data).every(isValid)
        }
        return false
    }

    const onSubmit = async () => {
        const findErrors = validationForm()
        setErrorForm(findErrors)
        if (!isValid(findErrors)) return

        let files = {}
        if (brandDetail?.title_image_url?.file) files = { ...files, title_image_url: brandDetail?.title_image_url }

        let payload = { ...brandDetail }

        const fileArray = brandDetail.brands
            .map((item, index) => ({ ...item, currentIndex: index }))
            .filter((item) => item?.image_url?.file)

        if (fileArray.length > 0) {
            files = { ...files, brands: fileArray }
        }

        if (Object.entries(files).length > 0) {
            setLoadingUpload(true)
            const filePayload = await handleUploadImage(files)
            if (filePayload?.title_image_url) {
                payload = {
                    ...payload,
                    title_image_url: filePayload?.title_image_url,
                }
            }

            if (filePayload?.brands?.length > 0) {
                for (const itemFile of filePayload?.brands) {
                    payload.brands[itemFile?.currentIndex].image_url = itemFile?.image_url
                }
            }
            setLoadingUpload(false)
        }
        await updateBrand(payload)
        await fetchBrand()
        Alert({
            icon: 'success',
            title: 'Success',
            message: 'Brand Section Updated!',
        })
    }

    const props = {
        data: brandDetail,
        items: copyItems,
        setItems,
        onChangeForm,
        onChangeItem,
        onAddNewItem,
        errorForm,
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }
    return <BrandSection {...props} />
}
